import { sessionResponse } from "~/backend/validate.js";
/** @import { webauthnLoginBody } from "~/backend/validate.js"; */
import { apiRequest, authedApiRequest, ApiError, response } from "~/lib/api.js";
import { clearSession } from "~/lib/session.js";

const expectedErrors = new Set(["limit_reached", "personal_machine_blocked"]);

/**
 * @param {string} email
 * @param {string} password
 * @param {object} [extra]
 * @param {string} [extra.tfa]
 * @param {string} [extra.machineId]
 */
export async function logInWithPassword(email, password, { tfa, machineId } = {}) {
	try {
		const json = await apiRequest("POST", "/v2/auth/session", {
			json: { email, password, machine_id: machineId, tfa_code: tfa },
			schema: response(sessionResponse),
		});

		return { token: json.data.token, machineId };
	} catch (err) {
		if (!expectedErrors.has(ApiError.from(err).code)) throw err;
		if (!machineId) throw err;
		return logInWithPassword(email, password, { tfa });
	}
}

/**
 * @param {Omit<webauthnLoginBody, "machine_id">} credential
 * @param {object} [extra]
 * @param {string} [extra.machineId]
 * @returns {Promise<{ token: string; machineId?: string }>}
 */
export async function logInWithPasskey(credential, { machineId } = {}) {
	try {
		const json = await apiRequest("POST", "/v2/auth/webauthn/finish", {
			json: { ...credential, machine_id: machineId },
			schema: response(sessionResponse),
		});

		return { token: json.data.token, machineId };
	} catch (err) {
		if (!expectedErrors.has(ApiError.from(err).code)) throw err;
		if (!machineId) throw err;
		return logInWithPasskey(credential);
	}
}

export function logOut() {
	authedApiRequest("DELETE", "/v2/auth/session");
	clearSession();
}
